import { defineComponent as _defineComponent } from 'vue'
import { useThemeModel } from '@entities/theme'
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewIconStar',
  props: {
  active: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false
  }
},
  setup(__props) {

const props = __props



const themeModel = useThemeModel()

return { __sfc: true,props, themeModel }
}

})